module.exports = __webpack_public_path__ + "static/media/search-claims.14095056.svg";